export function useAttainConfig() {
  return useRuntimeConfig().public.attain
}
